import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { useRechten } from "./context/RechtenContext";

export default function Home() {
  const { rechten, loading } = useRechten();
  const { instance, accounts } = useMsal();
  const [upn, setUpn] = useState("");
  const navigate = useNavigate();

  const NGW_TENANT_ID = "601774b8-d827-4636-92d7-934d5fceff0f";
  const isNGW =
    typeof rechten?.TenantID === "string" &&
    rechten.TenantID.trim().toLowerCase() === NGW_TENANT_ID.toLowerCase();

  const buttonClass =
    "w-full px-6 py-3 text-lg rounded-2xl shadow bg-gray-100 text-gray-800 hover:bg-gray-200 transition border border-gray-300";

  // UPN ophalen
  useEffect(() => {
    const active = instance.getActiveAccount();
    const user = active || accounts[0];
    if (user) {
      setUpn(user.username.toLowerCase());
      instance.setActiveAccount(user);
    }
  }, [instance, accounts]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-500">
        Rechten worden geladen..
      </div>
    );
  }

  // === Dynamisch kaarten verzamelen ===
  const cards = [];

  if (
    rechten?.GebruikersOverzicht ||
    rechten?.GebruikersActies ||
    rechten?.GebruikersBeheer ||
    rechten?.AanvragenBeoordelen ||
    rechten?.FullAccess ||
    rechten?.Administrator
  ) {
    cards.push(
      <div
        key="beheer"
        className="bg-white shadow-xl rounded-2xl p-6 space-y-4 w-full max-w-sm"
      >
        <h2 className="text-lg font-bold mb-4 text-center text-gray-700">
          Beheer & overzicht
        </h2>
        {(rechten?.GebruikersOverzicht ||
          rechten?.FullAccess ||
          rechten?.Administrator) && (
          <button
            onClick={() => navigate("/gebruikers-overzicht")}
            className={buttonClass}
          >
            Gebruikersoverzicht
          </button>
        )}
        {(rechten?.GebruikersActies ||
          rechten?.FullAccess ||
          rechten?.Administrator) && (
          <button
            onClick={() => navigate("/gebruikersacties")}
            className={buttonClass}
          >
            Gebruiker (de)blokkeren
          </button>
        )}
        {(rechten?.GebruikersBeheer ||
          rechten?.FullAccess ||
          rechten?.Administrator) && (
          <button
            onClick={() => navigate("/gebruikersbeheer")}
            className={buttonClass}
          >
            Gebruikersbeheer
          </button>
        )}
        {(rechten?.AanvragenBeoordelen ||
          rechten?.FullAccess ||
          rechten?.Administrator) && (
          <button
            onClick={() => navigate("/aanvragenbeoordelen")}
            className={buttonClass}
          >
            Aanvragen beoordelen
          </button>
        )}
      </div>
    );
  }

  cards.push(
    <div
      key="zelf"
      className="bg-white shadow-xl rounded-2xl p-6 space-y-4 w-full max-w-sm"
    >
      <h2 className="text-lg font-bold mb-4 text-center text-gray-700">
        Zelf regelen
      </h2>
      <button onClick={() => navigate("/mijnaanvragen")} className={buttonClass}>
        Mijn Aanvragen
      </button>
      {(rechten?.VakantieMFA || rechten?.FullAccess || rechten?.Administrator) && (
        <button onClick={() => navigate("/vakantie")} className={buttonClass}>
          Toegang buitenland aanvragen
        </button>
      )}
      {(rechten?.AgendaToegangBeheer ||
        rechten?.FullAccess ||
        rechten?.Administrator) && (
        <button onClick={() => navigate("/agendatoegang")} className={buttonClass}>
          Agenda Toegang
        </button>
      )}
      {(rechten?.MailboxToegangBeheer ||
        rechten?.FullAccess ||
        rechten?.Administrator) && (
        <button onClick={() => navigate("/mailboxtoegang")} className={buttonClass}>
          Mailbox Toegang
        </button>
      )}
      <button onClick={() => navigate("/feedback")} className={buttonClass}>
        Feedback & suggesties
      </button>
    </div>
  );

  if (isNGW) {
    cards.push(
      <div
        key="admin"
        className="bg-white shadow-xl rounded-2xl p-6 space-y-4 w-full max-w-sm"
      >
        <h2 className="text-lg font-bold mb-4 text-center text-gray-700">
          Admin menu
        </h2>
        <button onClick={() => navigate("/klantbeheer")} className={buttonClass}>
          Klantbeheer openen
        </button>
        {rechten?.Administrator && (
          <button onClick={() => navigate("/adminbeheer")} className={buttonClass}>
            Adminbeheer
          </button>
        )}
      </div>
    );
  }

  // === Grid classes afhankelijk van aantal cards ===
  const gridCols =
    cards.length === 1
      ? "grid-cols-1"
      : cards.length === 2
      ? "grid-cols-2"
      : "grid-cols-3";

  return (
    <div className="max-w-7xl mx-auto px-6 py-10 space-y-10">
      {/* Welkom card */}
      <div className="flex justify-center">
        <div className="bg-white shadow-xl rounded-2xl p-8 text-center w-full max-w-sm">
          <img
            src="/logo-nextgen.jpg"
            alt="NextGen Workspace"
            className="mb-4 w-48 mx-auto"
          />
          <h1 className="text-2xl font-semibold mb-2">
            Welkom op het Klantportaal
          </h1>
          <p className="text-sm text-gray-500">Ingelogd als: {upn}</p>
        </div>
      </div>

      {/* Dynamische grid met kaarten */}
      {/* Dynamische grid met kaarten */}
<div
  className={`grid ${gridCols} gap-8 justify-center ${
    cards.length === 2 ? "max-w-3xl mx-auto" : "max-w-7xl"
  }`}
>
  {cards}
</div>
    </div>
  );
}
